import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-waiting-room.html';

import {WaitingRoomService} from "@nuskin/ns-util";

/**
 * This is a custom element that is used when the waiting room is turned on in front of the checkout application.
 * We wanted to be able to use the waiting room in front of any place that might have high traffic, so we created this element.
 *
 */
export class NsWaitingRoom extends PolymerElement {
    static get is() {
        return "ns-waiting-room";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
    }

    static get properties() {
        return {
            status: {
                type: String,
                notify: true,
                reflectToAttribute: true
            },
            queue: {
                type: String,
                value: null
            },
            serving: {
                type: Boolean,
                value: false,
                observer: 'servingStatusChanged'
            },
            secKey: {
                type: String,
                value: '',
                observer: 'secKeyChanged'
            },
            information: {
                type: String,
                value: "<h1>You Have Been Placed In Line</h1>"
            },
            position: {
                type: String,
                value: 'Your position in line is {position} out of {total}'
            },
            waittime: {
                type: String,
                value: 'Your estimated wait time is {waitTime}'
            }
        }
    }

    constructor() {
        super();
    }

    ready() {
        super.ready();

        this.display = 'hide';
        if (this.serving) {
            this.startWaitingRoom();
        }
    }

    servingStatusChanged(newValue, oldValue) {
        if (oldValue !== undefined) {
            if (newValue === true) {
                this.startWaitingRoom();
            } else {
                this.closeWaitingRoom();
            }
        }
    }

    secKeyChanged(newValue) {
        console.log('New value for secondary key:', newValue);
    }

    startWaitingRoom() {
        let scope = this;
        try {
            WaitingRoomService.checkTicketStatus(scope.queue, scope.secKey, function (data) {
                if (data.queueStatus === 'open') {
                    // The 'data' fetched from the aem waiting room service
                    // should have a queue and ticket status. Process the data below.
                    scope.processTicketCheck(data);
                } else {
                    scope.closeWaitingRoom();
                }
            });
        } catch(exception) {  // Just in case there's no configured waiting room service:
            console.error('ns-waiting-room exception: ' + exception.message);
            scope.closeWaitingRoom();
        }
    }

    showWaitingRoom(data) {
        let scope = this;
        setTimeout(function () {
            scope.status = 'waiting';
            scope.$.description.innerHTML = scope.information;
            // scope.positionText = scope.position.replace('{position}', data.linePosition);
            // scope.positionText = scope.positionText.replace('{total}', data.peopleWaiting);
            scope.timeText = scope.waittime.replace('{waitTime}', data.waitTime);
            document.getElementById('waiting-room').style['z-index'] = 2000000001;
            document.getElementById('waiting-room').style['padding'] = '15px';
            scope.display = 'show';
            setTimeout(function () {
                WaitingRoomService.checkTicketStatus(scope.queue, scope.secKey, function (ticketStatus) {
                    scope.processTicketCheck(ticketStatus);
                });
            }, data.pollingPeriod || 15000);
        }, 1);
    }

    closeWaitingRoom() {
        const scope = this;
        setTimeout(function() {
            scope.display = 'hide';
            scope.status = 'closed';
        }, 5);
    }

    processTicketCheck(data) {
        if (NsWaitingRoom.isQueueOpen(data.queueStatus)) {
            if (data.ticketStatus === 'served') {
                this.closeWaitingRoom();
            } else {
                this.showWaitingRoom(data);
            }
        } else {
            this.closeWaitingRoom();
        }
    }

    static isQueueOpen(queueStatus) {
        let rv = false;

        if (queueStatus === 'open' || queueStatus === 'waitList') {
            rv = true;
        }
        return rv;
    }
}

customElements.define(NsWaitingRoom.is, NsWaitingRoom);
